module.exports = __webpack_public_path__ + "static/Box8-9a38435c98d8761d8d7387c26c3fbd55.jpg";